module.exports = __webpack_public_path__ + "media/img/logos/kpmg-fda0da5025868dd254a1949a60c16208.svg";